import { ofType } from 'redux-observable';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import {
  fetchAssistants,
  fetchAssistantsSuccess,
  fetchAssistantsFailure,
  fetchAssistantDefault,
  fetchAssistantDefaultSuccess,
  fetchAssistantDefaultFailure,
  fetchFileOptions,
  fetchFileOptionsSuccess,
  fetchFileOptionsFailure,
  createAssistant,
  createAssistantSuccess,
  createAssistantFailure,
  deleteAssistant,
  deleteAssistantSuccess,
  deleteAssistantFailure,
  fetchUpdateForm,
  fetchUpdateFormSuccess,
  fetchUpdateFormFailure,
  updateAssistant,
  updateAssistantSuccess,
  updateAssistantFailure,
} from '../slices/assistantsSlice';

export const fetchAssistantsEpic = (action$, state$) =>
  action$.pipe(
    ofType(fetchAssistants.type),
    mergeMap((action) =>
      ajax({
        url: '/api/get_assistants/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => fetchAssistantsSuccess({ data: res.response.data })),
        catchError((err) =>
          of(
            fetchAssistantsFailure({
              msg:
                err?.response?.msg ||
                err?.message ||
                '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );

export const fetchAssistantDefaultEpic = (action$, state$) =>
  action$.pipe(
    ofType(fetchAssistantDefault.type),
    mergeMap((action) =>
      ajax({
        url: '/api/get_assistant_default/',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        timeout: 30000,
      }).pipe(
        map((res) => fetchAssistantDefaultSuccess({ data: res.response.data })),
        catchError((err) =>
          of(
            fetchAssistantDefaultFailure({
              msg:
                err?.response?.msg ||
                err?.message ||
                '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );

export const fetchFileOptionsEpic = (action$) =>
  action$.pipe(
    ofType(fetchFileOptions.type),
    mergeMap((action) =>
      ajax({
        url: '/api/get_files/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
        responseType: 'json',
      }).pipe(
        map((res) => fetchFileOptionsSuccess({ data: res.response?.data ?? [] })),
        catchError((err) =>
          of(
            fetchFileOptionsFailure({
              msg: err?.response?.msg || err?.message || '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );

export const createAssistantEpic = (action$, state$) =>
  action$.pipe(
    ofType(createAssistant.type),
    mergeMap((action) =>
      ajax({
        url: '/api/create_assistant/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => createAssistantSuccess({ data: res.response.data })),
        catchError((err) =>
          of(
            createAssistantFailure({
              msg:
                err?.response?.msg ||
                err?.message ||
                '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );

export const deleteAssistantEpic = (action$, state$) =>
  action$.pipe(
    ofType(deleteAssistant.type),
    mergeMap((action) =>
      ajax({
        url: '/api/delete_assistant/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => deleteAssistantSuccess({ data: res.response.data })),
        catchError((err) =>
          of(
            deleteAssistantFailure({
              msg:
                err?.response?.msg ||
                err?.message ||
                '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );

export const fetchUpdateFormEpic = (action$, state$) =>
  action$.pipe(
    ofType(fetchUpdateForm.type),
    mergeMap((action) =>
      ajax({
        url: '/api/get_assistant_data/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => fetchUpdateFormSuccess({ data: res.response.data })),
        catchError((err) =>
          of(
            fetchUpdateFormFailure({
              msg:
                err?.response?.msg ||
                err?.message ||
                '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );

export const updateAssistantEpic = (action$, state$) =>
  action$.pipe(
    ofType(updateAssistant.type),
    mergeMap((action) =>
      ajax({
        url: '/api/update_assistant/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => updateAssistantSuccess({ data: res.response.data })),
        catchError((err) =>
          of(
            updateAssistantFailure({
              msg:
                err?.response?.msg ||
                err?.message ||
                '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );
